/**
 * A function to obtain a maximum string with two initial letters from the user's name.
 *
 * Exmaples:
 * John Doe -> 'JD',
 * John -> 'J',
 * John Doe Smith -> 'JS'
 *
 * @param username The name of the user.
 * @returns The user's initials.
 */
export function getInitials(username: string | undefined): string {
  if (!username) return "";
  const allNames = username.trim().split(" ");
  const initials = allNames.reduce((acc, curr, index) => {
    if (index === 0 || index === allNames.length - 1) {
      acc = `${acc}${curr.charAt(0).toUpperCase()}`;
    }
    return acc;
  }, "");

  return initials;
}
